export const containProductImages = (state: string) => {
  // states in which stores upload tall compliance images that must not be cropped
  const tallImageStates = ['Utah', 'UT'];
  return tallImageStates.includes(state);
};
